let winWidth = $(window).width();

export let checkDeviceResolution = {
  isDesktop: winWidth > 1024,
  isTablet: winWidth <= 1023 && winWidth >= 768,
  isMobile: winWidth <= 767,
};

$(window).on('resize orientationchange', function () {
  winWidth = $(window).width();

  checkDeviceResolution = {
    isDesktop: winWidth > 1024,
    isTablet: winWidth <= 1023 && winWidth >= 768,
    isMobile: winWidth <= 767,
  };
});
